<br><br>
<div class="card-container encuesta">
    <mat-card class="example-card">
        <p>No tiene permiso autorizado</p>
    </mat-card>
</div>
